<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11">
		<g id="Group_29882" data-name="Group 29882" transform="translate(0.5 0.5)">
			<g id="Group_23895" data-name="Group 23895">
				<g id="Rectangle_8017" data-name="Rectangle 8017">
					<rect
						id="Rectangle_8017-2"
						data-name="Rectangle 8017"
						width="11"
						height="10"
						rx="2"
						fill="none"
						stroke="#5a677c"
						stroke-width="1"
					/>
				</g>
				<line id="Line_626" data-name="Line 626" y2="9" transform="translate(5.5 0.5)" fill="none" stroke="#5a677c" stroke-width="1" />
				<g id="Group_23895-2" data-name="Group 23895" transform="translate(0.5 3.5)">
					<line id="Line_627" data-name="Line 627" x2="10" fill="none" stroke="#5a677c" stroke-width="1" />
					<line id="Line_628" data-name="Line 628" x2="10" transform="translate(0 3)" fill="none" stroke="#5a677c" stroke-width="1" />
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'TableIndicatorSVG',
};
</script>

<style scoped lang="scss"></style>
